import { SET_REPORT_BUSINESS_UNIT_DIALOG } from 'reporting-action-components/dialog/dialogTypes';
import useSetReportsBusinessUnitProblem from 'reporting-action-components/reportingActions/setReportBusinessUnit/useSetReportsBusinessUnitProblem';
import { ACTION_ASSET_TYPES } from '../../constants/actionAssetTypes';
import { BulkSetBusinessUnitAction } from '../shared/setBusinessUnit/BulkSetBusinessUnitAction';
import { LACKS_BUSINESS_UNITS_ACCESS } from '../problems';
import { jsx as _jsx } from "react/jsx-runtime";
export const BulkSetReportBusinessUnitButton = props => {
  const {
    assets
  } = props;
  const problemAndMessage = useSetReportsBusinessUnitProblem({
    reports: assets
  });
  if (problemAndMessage.problem === LACKS_BUSINESS_UNITS_ACCESS) {
    return null;
  }
  return /*#__PURE__*/_jsx(BulkSetBusinessUnitAction, Object.assign({
    assetType: ACTION_ASSET_TYPES.REPORT,
    problemAndMessage: problemAndMessage,
    dialogType: SET_REPORT_BUSINESS_UNIT_DIALOG
  }, props));
};